// extracted by mini-css-extract-plugin
module.exports = {"containerCards":"llistatJocs_containerCards__8Kcpn"};